import { TFunction } from 'i18next';

export const getDayLabels = (t: TFunction, length: number): string => {
  if (length === 1) return t('dictionaries:lengthUnits.day');
  return t('dictionaries:lengthUnits.days');
};
